import { defineStore } from 'pinia';
import { api } from '@/api/client';
import type { Category, AwardEarned } from '@/api/types';
import { useAwardsStore } from '@/stores/awards';

interface CategoryCreateResponse { category: Category; awardsGranted: AwardEarned[] }

interface CategoriesState {
  items: Category[];
  loaded: boolean;
}

export const useCategoriesStore = defineStore('categories', {
  state: (): CategoriesState => ({ items: [], loaded: false }),
  getters: {
    byId: (s) => (id: string) => s.items.find((c) => c.id === id),
    homeworkLeren: (s) => s.items.find((c) => c.slug === 'hw-leren'),
  },
  actions: {
    async load(force = false) {
      if (this.loaded && !force) return;
      this.items = await api<Category[]>('GET', '/api/categories');
      this.loaded = true;
    },
    async create(name: string, color: string, pointsPerHour = 0) {
      const resp = await api<CategoryCreateResponse>('POST', '/api/categories', { name, color, pointsPerHour });
      this.items.push(resp.category);
      useAwardsStore().enqueue(resp.awardsGranted);
      return resp.category;
    },
    async setColor(id: string, color: string) {
      await api('PATCH', `/api/categories/${id}/color`, { color });
      const ix = this.items.findIndex((c) => c.id === id);
      if (ix >= 0) this.items[ix] = { ...this.items[ix], color };
    },
    async remove(id: string, opts: { reassign?: boolean } = {}) {
      const qs = opts.reassign ? '?reassign=true' : '';
      await api('DELETE', `/api/categories/${id}${qs}`);
      this.items = this.items.filter((c) => c.id !== id);
    },
  },
});
